import { useMemo } from 'react'
import { Ticket } from 'types/Event'

export const useTotalPriceTickets = (tickets?: Ticket[], isComplimentary?: boolean) => {
    return useMemo(() => {
        if (isComplimentary || !tickets) return 0

        return tickets.reduce((total: number, ticket: Ticket) => {
            return total + (ticket.price ? parseInt(ticket.price.toString(), 10) : 0)
        }, 0)
    }, [tickets, isComplimentary])
}
